const SUCCESS_TEST_RESULT_STATUS = 'success';
const ERROR_TEST_RESULT_STATUS = 'error';
const SKIPPED_TEST_RESULT_STATUS = 'skipped';
const UNKNOWN_TEST_RESULT_STATUS = 'unknown';

export const MAPPED_FIELDS_KEY = 'mappedFields';
export const GLOBAL_RUN_DATA = 'global-workflow-run-data'; // keep this naming to work with the uuid type and the server/ng
export const CONFIGURATIONS_FIELDS_KEY = 'configuration';
export const CONTEXT_NODE_FIELD_KEY = 'context-node';

export const PLY_ICON_SERVICE_SLUG = 'ply-logo-data-input-menu';

export const USER_CONFIGURATIONS_FIELDS_KEY = 'USER_CONFIGURATIONS_FIELDS_KEY';
export const GENERAL_CONFIGURATIONS_FIELDS_KEY = 'GENERAL_CONFIGURATIONS_FIELDS_KEY';

const TRIGGERING_USER_KEY_TITLE = 'User That Triggered The Flow';
const NEW_TRIGGERING_USER_KEY_TITLE = 'Triggering User';

export const KEY_TITLE_MAPPER = {
	[TRIGGERING_USER_KEY_TITLE]: NEW_TRIGGERING_USER_KEY_TITLE,
	Timestamp: 'Timestamp | UTC',
	Date: 'Date | UTC',
	Time: 'Time | UTC',
	'Timestamp User': 'Timestamp | User timezone',
	'Timestamp Workspace': 'Timestamp | Workspace timezone',
};

export const GLOBAL_DATA_PREFIX = `${GLOBAL_RUN_DATA}__`;

export const VIRTUAL_FIELDS = [GENERAL_CONFIGURATIONS_FIELDS_KEY, USER_CONFIGURATIONS_FIELDS_KEY, MAPPED_FIELDS_KEY]; // order is important, we use it to sort steps in DataInputMenu

export const CONFIGURATIONS_FIELDS = [GENERAL_CONFIGURATIONS_FIELDS_KEY, USER_CONFIGURATIONS_FIELDS_KEY];

export const TEST_RESULT_STATUSES = Object.freeze({
	SUCCESS: SUCCESS_TEST_RESULT_STATUS,
	ERROR: ERROR_TEST_RESULT_STATUS,
	SKIPPED: SKIPPED_TEST_RESULT_STATUS,
	UNKNOWN: UNKNOWN_TEST_RESULT_STATUS,
});

export const NODE_ERROR_CODES = {
	FLOW_REACHED_MAXIMUM_NODES_ALLOWED: 'workflow-node-0004',
	ACTION_NOT_ALLOWED: 'workflow-node-0006',
	SERVICE_NOT_ALLOWED: 'workflow-node-0014',
};

export const TEMP_NODE_ID_KEY_PREFIX = 'temp_';

export const OUTPUT_LABEL_VALUE_KEY = 'OUTPUT-LABEL-VALUE';
export const OUTPUT_LABEL_NESTED_KEY = 'OUTPUT-NESTED';
